handleUpdatePaymentMethodError